/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_wu_letters_meta_description = /** @type {(inputs: { letters: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Every word you can make from the letters ${i?.letters}, sorted by length, plus anagrams. Free word unscrambler.`)
};

const es_wu_letters_meta_description = /** @type {(inputs: { letters: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Todas las palabras que puedes formar con las letras ${i?.letters}, ordenadas por longitud, además de anagramas. Descifrador de palabras gratuito.`)
};

const de_wu_letters_meta_description = /** @type {(inputs: { letters: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Alle Wörter, die du aus den Buchstaben ${i?.letters} bilden kannst, sortiert nach Länge, plus Anagramme. Kostenloser Wortentwirrer.`)
};

const nl_wu_letters_meta_description = /** @type {(inputs: { letters: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Elk woord dat je kunt maken met de letters ${i?.letters}, gesorteerd op lengte, plus anagrammen. Gratis woordontwarraar.`)
};

const fr_wu_letters_meta_description = /** @type {(inputs: { letters: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Tous les mots que vous pouvez former avec les lettres ${i?.letters}, triés par longueur, ainsi que les anagrammes. Déchiffreur de mots gratuit.`)
};

const it_wu_letters_meta_description = /** @type {(inputs: { letters: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ogni parola che puoi formare con le lettere ${i?.letters}, ordinate per lunghezza, più gli anagrammi. Sblocca parole gratuito.`)
};

const pt_br2_wu_letters_meta_description = /** @type {(inputs: { letters: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Todas as palavras que você pode formar com as letras ${i?.letters}, organizadas por tamanho, além dos anagramas. Desembaralhador de palavras gratuito.`)
};

const pt_wu_letters_meta_description = /** @type {(inputs: { letters: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Todas as palavras que pode formar com as letras ${i?.letters}, ordenadas por comprimento, além dos anagramas. Desbaralhador de palavras gratuito.`)
};

const ja_wu_letters_meta_description = /** @type {(inputs: { letters: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.letters} の文字から作れるすべての単語を長さ順に表示し、アナグラムもあわせて紹介します。無料の文字並べ替えツール。`)
};

const zh_wu_letters_meta_description = /** @type {(inputs: { letters: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`从字母 ${i?.letters} 中能拼出的所有单词，按长度排序，另附易位构词。免费字母重组工具。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{ letters: NonNullable<unknown> }} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const wu_letters_meta_description = (inputs, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.wu_letters_meta_description(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("wu_letters_meta_description", locale)
	if (locale === "en") return en_wu_letters_meta_description(inputs)
	if (locale === "es") return es_wu_letters_meta_description(inputs)
	if (locale === "de") return de_wu_letters_meta_description(inputs)
	if (locale === "nl") return nl_wu_letters_meta_description(inputs)
	if (locale === "fr") return fr_wu_letters_meta_description(inputs)
	if (locale === "it") return it_wu_letters_meta_description(inputs)
	if (locale === "pt-BR") return pt_br2_wu_letters_meta_description(inputs)
	if (locale === "pt") return pt_wu_letters_meta_description(inputs)
	if (locale === "ja") return ja_wu_letters_meta_description(inputs)
	return zh_wu_letters_meta_description(inputs)
};